/**
 * New / Used / Demo classification. (E4, Ajay #4.)
 *
 * One source of truth for the vocabulary, its colours and its labels, so the
 * board chip, the board filter and the dashboard split lines cannot drift the
 * way the appointment type lists once did.
 *
 * The vocabulary is the backend's: `leads.vehicle_category`, which in turn
 * mirrors `vehicles.condition`. UNCLASSIFIED is a UI-only bucket for null — it
 * is never sent to the API as a value, only used as a filter.
 */

export const CATEGORY_META = {
  NEW:  { label: 'New',  short: 'NEW',  color: 'var(--accent)' },
  USED: { label: 'Used', short: 'USED', color: 'var(--success)' },
  DEMO: { label: 'Demo', short: 'DEMO', color: 'var(--warning)' },
};

/** Board filter options. Unclassified is a real choice: it finds broken capture. */
export const CATEGORY_FILTERS = [
  ['All', 'All'],
  ['NEW', 'New'],
  ['USED', 'Used'],
  ['DEMO', 'Demo'],
  ['UNCLASSIFIED', 'Unclassified'],
];

export const categoryMeta = (value) => CATEGORY_META[value] || null;
